import { render, staticRenderFns } from "./forceChange.vue?vue&type=template&id=f71879aa&scoped=true&"
import script from "./forceChange.vue?vue&type=script&lang=js&"
export * from "./forceChange.vue?vue&type=script&lang=js&"
import style0 from "./forceChange.vue?vue&type=style&index=0&id=f71879aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f71879aa",
  null
  
)

export default component.exports